import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const current = i18n.resolvedLanguage;

  const btn = (lng, label) => (
    <button
      onClick={() => i18n.changeLanguage(lng)}
      className={`language-button px-2 py-1 xs:px-2.5 xs:py-1.5 rounded-md text-xs xs:text-sm transition-all duration-200
        ${current === lng 
          ? 'bg-white text-black font-medium shadow-sm' 
          : 'bg-transparent text-gray-300 border border-gray-700 hover:border-white hover:text-white'
        }`}
      aria-pressed={current === lng}
      title={lng === 'en' ? 'English' : lng === 'hi' ? 'Hindi' : 'Urdu'}
    >
      {label}
    </button>
  );

  return (
    <div className="flex gap-1">
      {btn('en','EN')}
      {btn('hi','हिं')}
      {btn('ur','اردو')}
    </div>
  );
};

export default LanguageSwitcher;
